import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
    Box,
    Typography,
    Checkbox,
    RadioGroup,
    FormControlLabel,
    Radio,
    Rating,
    TextField,
    Button,
    IconButton,
    Card,
    Paper,
    Breadcrumbs,
    Tooltip,
    FormLabel,
} from "@mui/material";
import { useNavigate } from "react-router-dom"; // At the top
import { ArrowBack, CalendarToday } from "@mui/icons-material";
import Swal from "sweetalert2";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
    AssessmentAnswerGet,
    AssessmentEvaluateController,
    AssessmentVerifyGet,
    AssessmentVerifyUpdateController,
    postData,
} from "../../store/reducers/Formapireducer";
import toast from "react-hot-toast";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";

export default function VerifyAssessment() {
    const location = useLocation();
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const navigateBack = () => {
        navigate(-1);
    };
    const skillName = location.state?.skill || "Unknown Skill";

    const today = new Date().toLocaleDateString("en-GB");

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    //const [answers, setAnswers] = useState({});
    const [answers1, setAnswers1] = useState([]);
    const [preview, setPreview] = useState(false);


    const handlePreview = () => setPreview(true);
    const handleBackToQuestions = () => setPreview(false);
    //TIMER
    const [timer, setTimer] = useState(null);
    const params = useParams();

    const recID = params.id;
    const accessID = params.accessID;
    const screenName = params.screenName;
    const mode = params.Mode;
    const CompanyID = sessionStorage.getItem("compID");
    const AssessmentID = params.parentID1;

    // const EmployeeID = sessionStorage.getItem("EmpId");
    const EmployeeID = params.EmployeeID || 0;
    const state = location.state || {};
    useEffect(() => {
        if (!AssessmentID || !EmployeeID) return; // important

        setTimer(Date.now());

        dispatch(
            AssessmentVerifyGet({
                data: { AssessmentID, EmpID: EmployeeID, EmployeescheduledRecordID: recID },
            })
        );
    }, [AssessmentID, EmployeeID, recID, dispatch]);

    const data = useSelector(
        (state) => state.formApi.AssessmentVerifyGetData
    ) || [];

    const status = useSelector(
        (state) => state.formApi.AssessmentVerifyGetStatus
    );

    const getLoading = useSelector(
        (state) => state.formApi.AssessmentVerifyGetLoading
    );

    console.log("DATA FROM REDUX:", data);

    // Remove duplicates — keep latest attempt
    const uniqueData = Object.values(
        data.reduce((acc, item) => {
            acc[item.QuestionCode] = item;
            return acc;
        }, {})
    );
    const EvaluateData = useSelector(
        (state) => state.formApi.AssessmentEvaluateData
    );
    console.log("🚀 ~ VerifyAssessment ~ EvaluateData:", EvaluateData)
    const EvaluateLoading = useSelector(
        (state) => state.formApi.AssessmentEvaluateLoading
    );
    //VALIDATION SCHEMA
    const validationSchema = Yup.object().shape({
        RecommendedComments: Yup.string().when("RecommendedOthers", {
            is: true,
            then: (schema) => schema.required("Comments are required"),
            otherwise: (schema) => schema.notRequired(),
        }),
    });


    const EvaluateAssessment = async (values) => {

        const idata = {
            data: {
                EmployeescheduledRecordID: recID,
                EmpID: EmployeeID,
                AssessmentID: AssessmentID,
                Details: uniqueData.map((q) => ({
                    QuestionGroupRecordID: q.QuestionGroupID,
                    QuestionsRecordID: q.QuestionID,
                    SelectedOption: q.SelectedOption,   // unchanged
                    SelectedRate:
                        q.AnswerType === "Y"
                            ? Number(values[q.QuestionCode] || 0)
                            : Number(q.SelectedRate || 0)
                }))
            }
        };

        const response = await dispatch(
            AssessmentEvaluateController({ idata })
        );

        if (response.payload.Status === "P") {
            // toast.success(response.payload.Score);
        } else {
            // toast.error(response.payload.Msg || "Error");
        }
    };
    const AssessmentSaveFn = async (values) => {

        const idata = {
            data: {
                EmployeescheduledRecordID: recID,
                EmpID: EmployeeID,
                AssessmentID: AssessmentID,
                RecommendedComments: values.RecommendedComments || "",
                RecommendedSkilled: values.RecommendedSkilled === true ? "Y" : "N",
                RecommendedCertified: values.RecommendedCertified === true ? "Y" : "N",
                RecommendedPromotion: values.RecommendedPromotion === true ? "Y" : "N",
                RecommendedOthers: values.RecommendedOthers === true ? "Y" : "N",

                Details: uniqueData.map((q) => ({
                    QuestionGroupRecordID: q.QuestionGroupID,
                    QuestionsRecordID: q.QuestionID,
                    SelectedOption: q.SelectedOption,   // unchanged
                    SelectedRate:
                        q.AnswerType === "Y"
                            ? Number(values[q.QuestionCode] || 0)
                            : Number(q.SelectedRate || 0)
                }))
            }
        };

        const response = await dispatch(
            AssessmentVerifyUpdateController({ idata })
        );

        if (response.payload.Status === "Y") {
            toast.success(response.payload.Msg);
            navigate(-1);
        } else {
            toast.error(response.payload.Msg || "Error");
        }
    };

    const fnLogOut = (props) => {
        Swal.fire({
            title: `Do you want ${props}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: props,
        }).then((result) => {
            if (result.isConfirmed) {
                if (props === "Logout") {
                    navigate("/");
                }
                if (props === "Close") {
                    navigate("/Apps/TR026/Department");
                }
            } else {
                return;
            }
        });
    };

    const isNonMobile = useMediaQuery("(min-width:600px)");

    const { toggleSidebar, broken, rtl } = useProSidebar();
    return (
        <>
            <React.Fragment
                sx={{
                    p: 2,
                    height: "100vh",
                }}
            >
                {/* BREADCRUMBS */}
                <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
                    <Box display="flex" justifyContent="space-between" p={2}>
                        <Box display="flex" borderRadius="3px" alignItems="center">
                            {broken && !rtl && (
                                <IconButton onClick={() => toggleSidebar()}>
                                    <MenuOutlinedIcon />
                                </IconButton>
                            )}
                            <Box
                                display={isNonMobile ? "flex" : "none"}
                                borderRadius="3px"
                                alignItems="center"
                            >
                                <Breadcrumbs
                                    maxItems={3}
                                    aria-label="breadcrumb"
                                    separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                                >
                                    <Typography
                                        variant="h5"
                                        color="#0000D1"
                                        sx={{ cursor: "default" }}
                                        onClick={() =>
                                            navigate("/Apps/TR308/List%20Of%20Assessment%20Type")
                                        }
                                    >
                                        List Of Assessment Type({state.BreadCrumb1})
                                    </Typography>

                                    <Typography
                                        variant="h5"
                                        color="#0000D1"
                                        sx={{ cursor: "default" }}
                                        onClick={() => navigate(-1)}
                                    >
                                        List Of{" "}
                                        {params.parentID2 === "AP"
                                            ? "Appraisal"
                                            : params.parentID2 === "CL"
                                                ? "Compliance"
                                                : params.parentID2 === "SK"
                                                    ? "Assessment"
                                                    : params.parentID2 === "SV"
                                                        ? "Survey"
                                                        : params.parentID2 === "FB"
                                                            ? "Feedback"
                                                            : ""}
                                        ({state.BreadCrumb2})

                                    </Typography>
                                    <Typography
                                        variant="h5"
                                        color="#0000D1"
                                        sx={{ cursor: "default" }}
                                    >
                                        {params.parentID2 === "AP"
                                            ? "Verify Appraisal"
                                            : params.parentID2 === "CL"
                                                ? "Verify Compliance"
                                                : params.parentID2 === "SK"
                                                    ? `Verify Assessment (${state.BreadCrumb4})`
                                                    : params.parentID2 === "SV"
                                                        ? "Verify Survey"
                                                        : params.parentID2 === "FB"
                                                            ? "Verify Feedback"
                                                            : ""}
                                    </Typography>
                                </Breadcrumbs>
                            </Box>
                        </Box>

                        <Box display="flex">
                            <Tooltip title="Close">
                                <IconButton onClick={() => fnLogOut("Close")} color="error">
                                    <ResetTvIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Logout">
                                <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                                    <LogoutOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>
                </Paper>

                {!getLoading ? (
                    <Paper elevation={3} sx={{ m: 2, p: 2 }}>
                        {/* <Typography variant="h4" gutterBottom>
                            Verify Assessment - {state.BreadCrumb2}
                        </Typography> */}
                        <Box display="flex" justifyContent="space-between">
                            <Typography variant="h4" gutterBottom>
                                Verify Assessment - {state.BreadCrumb2}
                            </Typography>
                            <Typography variant="h4" gutterBottom>
                                Marks
                            </Typography>
                        </Box>
                        <Formik
                            initialValues={{
                                ...uniqueData.reduce((acc, q) => {
                                    acc[q.QuestionCode] = q.SelectedRate || "0";
                                    return acc;
                                }, {}),

                                // RecommendedOption: "",
                                RecommendedSkilled: false,
                                RecommendedCertified: false,
                                RecommendedPromotion: false,
                                RecommendedOthers: false,
                                RecommendedComments: "",
                                VerifyBySelf: false
                            }}
                            validationSchema={validationSchema}
                            enableReinitialize
                            onSubmit={AssessmentSaveFn}
                        >
                            {({
                                handleChange,
                                values,
                                errors,
                                touched,
                                handleSubmit,
                            }) => (
                                <Form onSubmit={handleSubmit}>
                                    {/* QUESTIONS */}
                                    <Box mt={4}>
                                        {uniqueData.map((q) => (
                                            <Box key={q.RecordID} mb={3}>
                                                {/* <Box display="flex" justifyContent="space-between">
                                                <Typography>
                                                    {q.SLNO}. {q.Question}
                                                </Typography>
                                                <Typography sx={{textAlign: "center"}}>
                                                    Marks
                                                </Typography>
                                                </Box> */}
                                                <Typography>
                                                    {q.SLNO}. {q.Question}
                                                </Typography>
                                                <Box display="flex" gap={2} mt={1}>
                                                    {/* 80% USER ANSWER */}
                                                    <Box sx={{ width: "80%" }}>
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            // label="User Answer"
                                                            value={q.SelectedOption || ""}
                                                            InputProps={{
                                                                readOnly: true, disableUnderline: true,
                                                                sx: {
                                                                    paddingLeft: "15px"
                                                                }
                                                            }}
                                                            variant="standard"
                                                        />
                                                    </Box>

                                                    {/* 20% MARKS */}
                                                    <Box sx={{ width: "20%" }}>

                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            name={q.QuestionCode}
                                                            value={values[q.QuestionCode] || ""}
                                                            onChange={handleChange}
                                                            placeholder="Marks"
                                                            disabled={q.AnswerType !== "Y"}

                                                            inputProps={{
                                                                style: { textAlign: "right" }
                                                            }}

                                                            variant={q.AnswerType === "Y" ? "outlined" : "standard"}

                                                            InputProps={{
                                                                disableUnderline: q.AnswerType !== "Y"
                                                            }}

                                                        // variant="outlined"
                                                        // inputProps={{ style: { textAlign: "right" } }}
                                                        // sx={{
                                                        //     "& .MuiOutlinedInput-root": {
                                                        //         "& fieldset": {
                                                        //             borderColor: q.AnswerType === "Y" ? "primary.main" : "transparent",
                                                        //         },
                                                        //     },
                                                        // }}
                                                        />
                                                    </Box>
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                    <Box sx={{
                                        display:"flex",
                                        justifyContent:"flex-end"
                                    }}>
                                        <LoadingButton
                                            variant="contained"
                                            // type="submit"
                                            color="secondary"
                                            onClick={() => EvaluateAssessment(values)}
                                        >
                                            Evaluate
                                        </LoadingButton>
                                    </Box>
                                    {EvaluateData?.Status === "P" ? (
                                        <>
                                            <Typography variant="h6" mt={3} sx={{ fontWeight: "bold" }}>
                                                Recommendations:
                                            </Typography>

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="RecommendedSkilled"
                                                        checked={values.RecommendedSkilled}
                                                        onChange={handleChange}
                                                    />
                                                }
                                                label="Internally Skilled"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="RecommendedCertified"
                                                        checked={values.RecommendedCertified}
                                                        onChange={handleChange}
                                                    />
                                                }
                                                label="Internally Certified"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="RecommendedPromotion"
                                                        checked={values.RecommendedPromotion}
                                                        onChange={handleChange}
                                                    />
                                                }
                                                label="Eligible for Promotion"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="RecommendedOthers"
                                                        checked={values.RecommendedOthers}
                                                        onChange={handleChange}
                                                    />
                                                }
                                                label="Others"
                                            />

                                            <TextField
                                                name="RecommendedComments"
                                                label="Comments"
                                                multiline
                                                rows={4}
                                                fullWidth
                                                value={values.RecommendedComments}
                                                onChange={handleChange}
                                                error={touched.RecommendedComments && Boolean(errors.RecommendedComments)}
                                                helperText={touched.RecommendedComments && errors.RecommendedComments}
                                                sx={{ mt: 2 }}
                                            />
                                        </>
                                    ) : (null)}

                                    <Box>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="VerifyBySelf"
                                                    checked={values.VerifyBySelf}
                                                    onChange={handleChange}
                                                />
                                            }
                                            label="Verified & Evaluated by me"
                                        />
                                    </Box>

                                    {/* BUTTONS */}
                                    <Box mt={4} display="flex" gap={2} justifyContent="flex-end">

                                        {values.VerifyBySelf === true ? (
                                            <LoadingButton
                                                variant="contained"
                                                type="submit"
                                                color="secondary"
                                            >
                                                {/* Submit & Save */}
                                                Save & Submit
                                            </LoadingButton>) : (
                                            <LoadingButton
                                                variant="contained"
                                                // type="submit"
                                                color="secondary"
                                                disabled={true}
                                            >
                                                {/* Submit & Save */}
                                                Save & Submit
                                            </LoadingButton>)}
                                        <Button
                                            variant="contained"
                                            color="warning"
                                            onClick={() => navigate(-1)}
                                        >
                                            Cancel
                                        </Button>
                                    </Box>
                                </Form>
                            )}
                        </Formik>
                    </Paper>
                ) : (
                    false
                )}
            </React.Fragment >
        </>
    );
}
